import React, { useState , useEffect } from 'react';
import style from '../../Styles/Order/Order.module.css';
import CheckBox from '../../Components/Html/CheckBox.jsx'
import TextField from '../../Components/Html/TextField';
import Enum  from '../../Common/Enum/Enum';
import MessageAlert from '../../Components/Html/MessageAlert';

const IngredientsBeverageCheckboxs = ({ menuItem, checkboxValues, setCheckboxValues }) => {

      const [messagetext, setMessageText] = useState('');
      const [typeMessagetext, setTypeMessagetext] = useState();
          
      const handleCheckboxChange = (id, isChecked) => {

        const clickedIngredient = menuItem.ingredients.find(
            ingredient => ingredient.idmenuchartproduct === id
        ); 
        const dynamicPriceIngredients = menuItem.ingredients?.filter(
          ingredient => ingredient.isdynamicprice === Enum.ISDYNAMICPRICE
        ) || [];

        if (clickedIngredient.isdynamicprice === Enum.ISDYNAMICPRICE) {
            const selectedDynamicCount = dynamicPriceIngredients.filter(ing => checkboxValues[ing.idmenuchartproduct] === true).length;          
            if (isChecked && selectedDynamicCount >= 2) {
              setMessageText("Por favor seleccione 1 o 2 tipos de carne");            
              return;
            }
            if (isChecked) {
              menuItem.sellprice += clickedIngredient.price;
            } else {
              menuItem.sellprice -= clickedIngredient.price;
            }         
        }
        
        if (clickedIngredient && clickedIngredient.isbeverage === Enum.ISBEVERAGE) {
          if (isChecked){
            const newValues = {};
            menuItem.ingredients.forEach(ingredient => {
              if(ingredient.typeOfHtmlElement === Enum.ISCHECKBOX) {
                if (ingredient.idmenuchartproduct === id) {
                  newValues[ingredient.idmenuchartproduct] = true;
                } else if (ingredient.isbeverage === Enum.ISBEVERAGE) {
                  newValues[ingredient.idmenuchartproduct] = false;
                } else {
                  newValues[ingredient.idmenuchartproduct] = checkboxValues[ingredient.idmenuchartproduct] || false;
                }
              }
            });    
            setCheckboxValues(prev => ({
              ...prev,
              ...newValues
            }));            
          } else {
            setCheckboxValues(prev => ({
              ...prev,
              [id]: false
            }));
          }
        } else {
          setCheckboxValues(prev => ({
            ...prev,
            [id]: isChecked
          }));
        }
      };

      useEffect(() => {
        if (messagetext) {
          const timer = setTimeout(() => {
            setMessageText('');
            setTypeMessagetext(undefined);
          }, 3000);      
          return () => clearTimeout(timer);
        }
      }, [messagetext]);

  return (
    <div className={style.ingredientsBeverageAuxBlock}>
    <div className={style.ingredientTitle}>
        <div className={style.checkboxestitle}>Elige ingredientes y bebida </div>
    </div>

  <div className={style.ingredientsBeverageSubblock}>
        <div className={style.ingredientsblock}>
          <div className={style.listOfIngredients}>
            {menuItem.ingredients.map(ingredient => (
              ingredient.typeOfHtmlElement === Enum.ISCHECKBOX && ingredient.isbeverage !== Enum.ISBEVERAGE  
                                             && ingredient.isdynamicprice !== Enum.ISDYNAMICPRICE ? (
                <div key={ingredient.idmenuchartproduct} >
                  <div className={style.checkBackground}>
                    <CheckBox
                      name={ingredient.name} 
                      id={ingredient.idmenuchartproduct}
                      checked={checkboxValues[ingredient.idmenuchartproduct] ?? false}
                      onChange={handleCheckboxChange} 
                      isbeverage={ingredient.isbeverage}/>
                    </div>
                </div>
              ) : ingredient.typeOfHtmlElement !== Enum.ISCHECKBOX ? (
                <TextField 
                  key={ingredient.idProduct} 
                  name={ingredient.name} 
                  id={ingredient.idProduct}
                />
              ) : null
            ))}
          </div> 
        </div>   

        <div className={style.beverageblock}>                
          <div className={style.listOfIngredients}>
            {menuItem.ingredients.map(ingredient => (
              ingredient.typeOfHtmlElement === Enum.ISCHECKBOX && ingredient.isbeverage === Enum.ISBEVERAGE ? (
                <div key={ingredient.idmenuchartproduct}>
                  <div className={style.checkBackground}>
                    <CheckBox
                      name={ingredient.name} 
                      id={ingredient.idmenuchartproduct}
                      checked={checkboxValues[ingredient.idmenuchartproduct] ?? false}
                      onChange={handleCheckboxChange}
                      isbeverage={ingredient.isbeverage} />
                   </div>
                </div>
              ) : ingredient.typeOfHtmlElement !== Enum.ISCHECKBOX ? (
                <TextField 
                  key={ingredient.idProduct} 
                  name={ingredient.name} 
                  id={ingredient.idProduct}/>
              ) : null
            ))}
          </div> 
        </div>
  </div>
  <div className={style.dynamicPricesMain}>
          {menuItem.ingredients.some(ingredient => ingredient.isdynamicprice === Enum.ISDYNAMICPRICE) && (
          <div className={style.ingredientTitle}>
            <div className={style.checkboxestitle}>Elige tipo de carne</div>
            <MessageAlert text={messagetext} typeOfMessage={typeMessagetext}/>
          </div>
          )}

        <div className={style.dynamicPriceIngredientes }>       
            {menuItem.ingredients.map(ingredient => (
                  ingredient.typeOfHtmlElement === Enum.ISCHECKBOX && ingredient.isdynamicprice === Enum.ISDYNAMICPRICE ? (
                    <div key={ingredient.idmenuchartproduct}>                  
                      <div className={style.checkBackground}>
                        <CheckBox
                          name={ingredient.name} 
                          id={ingredient.idmenuchartproduct}
                          checked={checkboxValues[ingredient.idmenuchartproduct] ?? false}
                          onChange={handleCheckboxChange} 
                          isbeverage={ingredient.isbeverage}
                          isdynamicprice={ingredient.isdynamicprice}/>
                        </div>
                    </div>
                  ) : ingredient.typeOfHtmlElement !== Enum.ISCHECKBOX ? (
                    <TextField 
                      key={ingredient.idProduct} 
                      name={ingredient.name} 
                      id={ingredient.idProduct}
                    />
                  ) : null
                ))}
        </div> 
      </div>

  </div>
  )
}

export default IngredientsBeverageCheckboxs 